// Captures the URL hash before Vue Router's createWebHashHistory can modify it.
// This module must have NO imports and must be imported before the router module
// in main.ts so it executes first during ES module resolution.
const hash = window.location.hash;

export const capturedMsalHash: string | null =
  hash && !hash.startsWith('#/') && (hash.includes('code=') || hash.includes('error='))
    ? hash
    : null;
